import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class TrackingIdGuard {
  constructor(private storage: StorageService, @Inject(PLATFORM_ID) private platformId: string) {}

  canActivate(next: ActivatedRouteSnapshot): true {
    if (!isPlatformBrowser(this.platformId)) return true;
    if (next.queryParams._cio_id) {
      this.storage.set('_cio_id', next.queryParams._cio_id, true);
    }
    return true;
  }
}
